import { DateTime, DateTimeOptions } from 'luxon'

export const isToday = (date: DateTime, tz?: DateTimeOptions['zone']) => {
  return date.hasSame(DateTime.utc().setZone(tz), 'day')
}
export const isTomorrow = (date: DateTime, tz?: DateTimeOptions['zone']) => {
  return date.hasSame(DateTime.utc().setZone(tz).plus({ days: 1 }), 'day')
}
